import React, { Component, Fragment } from 'react';
import ProfileDetails from './ProfileDetails';
import CurrentPlan from './CurrentPlan';
import AffiliateDetails from './AffiliateDetails';

import { HeaderLoggedIn } from 'scenes/Header';
import FixedFooter from 'components/FixedFooter';
class Profile extends Component {
  static propTypes = {};

  render() {
    return (
      <Fragment>
        <HeaderLoggedIn />
        <div className="profile container profile-details__container">
          <div className="profile__content">
            <div className="b-row">
              <div className="b-col-12 b-col-sm-12 p-r-30">
                <ProfileDetails />
                <CurrentPlan />
                <AffiliateDetails />
              </div>
            </div>
          </div>
        </div>
        <FixedFooter />
      </Fragment>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/scenes/Profile/Profile.js